import Button from "devextreme-react/button";
import Drawer from "devextreme-react/drawer";
import ScrollView from "devextreme-react/scroll-view";
import Toolbar, { Item } from "devextreme-react/toolbar";
import React, { useEffect, useState, useCallback, useRef } from "react";
import { useNavigate } from "react-router";
import { useLocation } from "react-router-dom";
import { Header, SideNavigationMenu, Footer } from "../../components";
import "./side-nav-inner-toolbar.scss";
import { useScreenSize } from "../../utils/media-query";
import { Template } from "devextreme-react/core/template"; 
import { useMenuPatch } from "../../utils/patches";
//import logo from "../../assets/auth-logo-dark.png";
export default function SideNavInnerToolbar({ title, children }) {
  const scrollViewRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();
  const { isXSmall, isLarge } = useScreenSize();
  const [patchCssClass, onMenuReady] = useMenuPatch();
  const [menuStatus, setMenuStatus] = useState(
    isLarge ? MenuStatus.Opened : MenuStatus.Closed
  );

  // maxSize controla el ancho del panel del Drawer cuando está abierto.
  // MENU_WIDTH llega async desde public/config.js (fetch), así que al primer render puede ser null.
  // Si pasamos NaN a DevExtreme, el width no se aplica. Usamos fallback + espera corta.
  const [maxSize, setMaxSize] = useState(300);

  useEffect(() => {
    const readMaxSize = () => {
      const raw = localStorage.getItem("MENU_WIDTH");
      const px = Number.parseInt(raw ?? "", 10);
      return Number.isFinite(px) ? px : null;
    };

    const initial = readMaxSize();
    if (initial !== null) {
      setMaxSize(initial);
      return;
    }

    let tries = 0;
    const timer = setInterval(() => {
      tries += 1;
      const v = readMaxSize();
      if (v !== null) {
        setMaxSize(v);
        clearInterval(timer);
        return;
      }
      if (tries >= 40) clearInterval(timer); // ~2s
    }, 50);

    return () => clearInterval(timer);
  }, []);

  // Quitar el scroll externo del layout (ScrollView) en rutas tipo "/process/*" y "/reports/*"
  useEffect(() => {
    const path = location?.pathname || "";
    const disableOuterScroll = path.includes("/process") || path.includes("/reports");
    document.body.classList.toggle("process-no-outer-scroll", disableOuterScroll);

    return () => {
      document.body.classList.remove("process-no-outer-scroll");
    };
  }, [location?.pathname]);

  const toggleMenu = useCallback(({ event }) => {
    setMenuStatus((prevMenuStatus) =>
      prevMenuStatus === MenuStatus.Closed
        ? MenuStatus.Opened
        : MenuStatus.Closed
    );
    event.stopPropagation();
  }, []);

  const temporaryOpenMenu = useCallback(() => {
    setMenuStatus((prevMenuStatus) =>
      prevMenuStatus === MenuStatus.Closed
        ? MenuStatus.TemporaryOpened
        : prevMenuStatus
    );
  }, []);

  const onOutsideClick = useCallback(() => {
    setMenuStatus((prevMenuStatus) =>
      prevMenuStatus !== MenuStatus.Closed && !isLarge
        ? MenuStatus.Closed
        : prevMenuStatus
    );
    return menuStatus === MenuStatus.Closed ? true : false;
  }, [isLarge]);

  const onNavigationChanged = useCallback(
    ({ itemData, event, node }) => {
      console.log("item data", itemData);

      if (menuStatus === MenuStatus.Closed || !itemData.ItemPath) {
        event.preventDefault();
        return;
      }

      navigate(itemData.ItemPath);
      scrollViewRef.current.instance.scrollTo(0);

      if (!isLarge || menuStatus === MenuStatus.TemporaryOpened) {
        setMenuStatus(MenuStatus.Closed);
        event.stopPropagation();
      }
    },
    [navigate, menuStatus, isLarge]
  );

  const colorHeader = localStorage.getItem('COLOR_HEADER');
  const colorMenu = localStorage.getItem('COLOR_MENU');
  const colorMenuText = localStorage.getItem('COLOR_MENU_TEXT');

  const isDev = false; //window.location.href.includes('localhost') || window.location.href.includes('dev.')
  const returnLogo = () => {
    //color: ${colorMenuText};
    return `<span class="logo" style="font-size: 22px; margin-right: 40px;">${isDev ? "Dev" : "Signos Framework"}</span>`;
  };

  return (
    <div className={"side-nav-inner-toolbar"}>
      <Drawer
        className={["drawer", patchCssClass].join(" ")}
        position={"before"}
        closeOnOutsideClick={onOutsideClick}
        openedStateMode={isLarge ? "shrink" : "overlap"}
        revealMode={isXSmall ? "slide" : "expand"}
        minSize={isXSmall ? 0 : 76}
        maxSize={maxSize}
        shading={isLarge ? false : true}
        opened={menuStatus === MenuStatus.Closed ? false : true}
        template={"menu"}
      >
        <div className={"container"}>
          <Header menuToggleEnabled={isXSmall} toggleMenu={toggleMenu} showTitle={menuStatus === MenuStatus.Closed} />
          <ScrollView ref={scrollViewRef} className={"layout-body with-footer"}>
            <div className={"content"}>
              {React.Children.map(children, (item) => {
                return item.type !== Footer && item;
              })}
            </div>
            <div className={"content-block"}>
              {React.Children.map(children, (item) => {
                return item.type === Footer && item;
              })}
            </div>
          </ScrollView>
        </div>
        <Template name={"menu"}>
          <SideNavigationMenu
            compactMode={menuStatus === MenuStatus.Closed}
            selectedItemChanged={onNavigationChanged}
            openMenu={temporaryOpenMenu}
            onMenuReady={onMenuReady}
          >
            <Toolbar
              elementAttr={{
                id: "navigation-header",
                // DevExtreme pinta el fondo real en elementos internos; pasamos variables CSS
                // y las consumimos desde SCSS con !important para ganar al tema.
                //--nav-header-text: ${colorMenuText};
                style: `--nav-header-bg: ${colorHeader};`,
              }}
              className={menuStatus === MenuStatus.Closed ? "header-closed" : "header-opened"}
            >
              {!isXSmall && (
                <Item location={"before"} cssClass={"menu-button"} >
                  <Button stylingMode="text" onClick={toggleMenu}>
                    <i
                      className="fa-thin fa-bars"
                      style={{
                        fontSize: "26px",
                        marginLeft: "17px",
                        marginRight: "20px",
                        color: colorHeader,
                      }}
                    ></i>
                  </Button>
                </Item>
              )}

              <Item
                html={returnLogo()}
                location={"before"}
                cssClass={"header-title"}
                // text={title}
              />
            </Toolbar>
          </SideNavigationMenu>
        </Template>
      </Drawer>
    </div>
  );
}

const MenuStatus = {
  Closed: 1,
  Opened: 2,
  TemporaryOpened: 3,
};
